import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import RSVP from 'rsvp';
import { service } from '@ember/service';

export default Route.extend({
  fundsService: service(),
  storeCache: service(),
  navbarSettings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Remove Fund Permission');
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    let fundModel = this.modelFor('admin.funds.fund');
    let fund = get(fundModel, 'record');
    let user = get(fundModel, 'users').find((user) => {
      return get(user, 'id') === params.userId;
    });

    let storeCache = this.storeCache;
    let promise = RSVP.hash({
      indexUserFundsByUserId: storeCache.indexMultipleBy(
        'admin/user-fund',
        'userId',
      ),
    });

    return promise.then((data) => {
      let userFundPermissions = data.indexUserFundsByUserId[get(user, 'id')];
      let fundPermission = userFundPermissions.find((fundPermission) => {
        return get(fundPermission, 'fundId') === get(fund, 'id');
      });
      return {
        fund: fund,
        user: user,
        fundPermission: fundPermission,
        userFundPermissionsCount: userFundPermissions.length,
      };
    });
  },
});
